import { TransactionStatusType } from './transaction.model';

// Generated by https://quicktype.io

export interface DevicesModel {
	totalPages: number;
	totalItems: number;
	responseCode: string;
	records: Record[];
}

export interface Record {
	id: number;
	manufacturer: string;
	model: string;
	uniqueIdentifier: string;
	deviceType: string;
	user: User;
	state: string;
	loginState: string;
	lastLogin: null | string;
	createdOn: string;
	lastModifiedOn: string;
}

export interface User {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	username: string;
	firstName: string;
	middleName: string;
	lastName: string;
	emailAddress: string;
	mobileNumber: string;
	roles: string[];
	authorities: string[];
	tokenData: TokenData;
	status: string;
}

export interface TokenData {
	username: string;
	firstName: string;
	lastName: string;
	roles: string[];
	authorities: string[];
	expires_in: number;
	phone?: any;
	contractCode?: any;
}

export class DeactivateDeviceModel {
	newState: string;
	uniqueDeviceIdentifier: any;
	uniqueIdentifierOfDeviceToUpdate: string;
	userId: number;
}

// Generated by https://quicktype.io

export interface DeviceRegistrationOtpModel {
	code: string;
	description: string;
	responseCode: string;
	responseMessage: string;
	message: string;
	activationToken: string;
	profile: any;
	tokenData: TokenData;
	ussdCode: string;
	retryTimer: number;
	identifier: string;
	phoneNumber?: any;
}

export class AirtimeRequestModel {
	agentPin: string;
	airtimeNetworkId: number;
	amount: number;
	contractCode: string;
	customerPhoneNumber: string;
	uniqueDeviceIdentifier: string; // uniqueDeviceIdentifier
	paymentReference: string;
}

export class CashoutRequestModel {
	amount: number;
	uniqueDeviceIdentifier: string; // uniqueDeviceIdentifier
}

export class DepositRequestModel {
	acctNoStatus: string; // valid
	agentPin: string;
	amount: number;
	contractCode: string;
	customerName: string;
	emailAddress: string;
	nameEnquiryCacheReference: string;
	narration: string;
	phoneNumber: string;
	recipientAccountName: string;
	recipientAccountNumber: string;
	recipientBankCbnCode: string;
	uniqueDeviceIdentifier: string;
}

export class DeviceRegistrationRequestModel {
	deviceUniqueIdentifier: any;
	manufacturer = 'Mac OS';
	model = 'Chrome';

	constructor(obj?) {
		this.deviceUniqueIdentifier = obj && obj.deviceUniqueIdentifier;
		this.manufacturer = (obj && obj.manufacturer) || 'Mac OS';
		this.model = (obj && obj.model) || 'Chrome';
	}
}

export class ActivateDeviceRequestModel {
	activationToken: string;
	channel: string;
	deviceUniqueIdentifier: any;
	otp?: any;
	username?: string;
	password?: string;
	ussdCode?: any;
	identifier: any;
	reference?: string;
	loginType?:string;
	businessId?:string;
	refreshToken?:string;
	otpValidationKey?:string;
	role?: string;

	constructor(obj?) {
		this.deviceUniqueIdentifier = obj && obj.deviceUniqueIdentifier;
		this.username = obj && obj.username;
		this.password = obj && obj.password;
		this.channel = (obj && obj.channel) || 'WEB';
		this.ussdCode = obj && obj.ussdCode;
		this.identifier = obj && obj.identifier;
		this.activationToken = obj && obj.activationToken;
		this.loginType = obj && obj.loginType;
		this.businessId = obj && obj.businessId;
		this.refreshToken = obj && obj.refreshToken;
		this.otpValidationKey = obj && obj.otpValidationKey;
		this.role = obj && obj.role;
	}
}

export interface DeviceInformation {
	manufacturer: string;
	deviceUniqueIdentifier: string;
	model: string;
	identifier?: string;
	encryptedDeviceId?: any;
}


export interface AirtimeNetworkDto {
	id: number;

	name: string;

	billerCode: string;

	shortName: string;

	enabled: boolean;

	businessSchemeDto: BusinessSchemeDto;

	airtimeProviders: AirtimeProviderDto[];

	icon?: string;
}

export interface BusinessSchemeDto {
	id: number;

	name: string;

	code: string;
}

export interface AirtimeProviderDto {
	id: number;

	name: string;
}

export interface Bank {
	cbnCode: string;
	code: string;
	id: number;
	name: string;
	status: string;
}

export interface BillerCategory {
	code: string;
	id: number;
	name: string;
	status: string;
	responseCode: string;
}

export interface Biller {
	category: BillerCategory;
	code: string;
	customerIdName: string;
	customerIdNameLength: number;
	id: number;
	name: string;
	status: string;
}

export interface BillerProduct {
	additionalInfoResponseFields: string;
	amount: number;
	biller: Biller;
	code: string;
	defaultBusinessScheme: DefaultBusinessScheme;
	hasFixedAmount: boolean;
	id: number;
	maximumAmount: any;
	minimumAmount: any;
	name: string;
	status: string;
	responseCode: string;
}

export interface DefaultBusinessScheme {
	code: string;
	enableBatchPosting: boolean;
	id: number;
	name: string;
}

export interface PaymentValidationResponse {
	status: TransactionStatusType;
	responseCode: string;
	responseMessage: string;
	customerName: string;
	customerValidationReferenceNumber: string;
	customerValidationOptionalFixedAmount: number;
}

export class PaymentValidationRequest {
	billerCode: string;
	billerProductCode: string;
	customerId: string;
}

export enum Channel {
	POS,
	WEB,
	MOBILE,
}

export class WebClientBillPaymentRequest {
	billerCode: string;

	billerProductCode: string;

	customerId: string;

	customerName: string;

	customerEmail: string;

	customerPhoneNumber: string;

	customerValidationReferenceNumber: string;

	customerValidationOptionalFixedAmount: number;

	amount: number;

	agentPin: string;

	contractCode: string;

	uniqueDeviceIdentifier: string;

	channel: Channel;

	paymentReference: string;
}

export interface GridTerminalModel {
	totalPages: number;
	totalItems: number;
	records: GridTerminals[];
}

export interface TerminalInsuranceModel {
	subscriptionStatus: string;
	id: number;
	startDate: string;
	dueDate: string;
	insurancePlan: InsurancePlan;
}

export interface InsurancePlan {
	annualLimit: any;
	createdOn: string;
	description: string;
	duration: number;
	id: number;
	lastModifiedOn: string;
	limitPerOccurrence: any;
	moniepointFee: any;
	name: string;
	planType: string;
	premiumPaymentFrequency: any;
	providerFee: any;
	status: string;
}

export interface GridTerminals {
	activationAmount: number;
	agentContractId?: any;
	enableDynamicPricing?: any;
	id: number;
	insuranceFee: number;
	maximumAggregatorFee: number;
	serialNo: string;
	range: string;
	agentName: string;
	agentMobile: string;
}

export interface AgentStats {
	agentCreatedOn: string;
	agentId: number;
	airtimeValue: number;
	airtimeVolume: number;
	billPaymentValue: number;
	billPaymentVolume: number;
	businessEmail: string;
	businessName: string;
	depositValue: number;
	depositVolume: number;
	firstName: string;
	lastName: string;
	uniqueCards: number;
	username: string;
	withdrawalValue: number;
	withdrawalVolume: number;
}

export interface TerminalSwapCharges {
	brmCommissionMinor: number;
	activationFeeMinor: number;
	insuranceChargeMinor: number;
	insuranceExcessMinor: number;
	repairChargeMinor: number;
	swapChargeMinor: number;
}

export interface SwapEligibilityValidationResponse {
	swapValidity?: boolean;
	salvageValue?: number;
	lastTransactionDate?: string;
	terminalId?: number;
	serialNo?: string;
	remarkTitle?: string;
	remarkBody?: string;
	pendingTC?: {
		id: number;
		gracePeriodDate: string;
		businessId: number;
	}
}

export interface SwapableTerminalsResponse {
	id: number;
	serialNo: string;
	ownershipState: string;
	terminalState: string;
	terminalType: string;
	manufacturer: string;
	model: string;
}

export interface GenerateReferenceApiPayload {
	deviceUniqueIdentifier: string;
}
